import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import FeedVideoAutoplay from "%/dynamic-component-editor/options/feed-video-autoplay";

export default class FeedPlaybackOptions extends BaseOptionsBundle {

  optionTitle = "Playback";
  static optionClassName = "i-feed-playback";
  inspectorToolGroup = "feedPlayback";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.GROUPED_OPTIONS_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      new FeedVideoAutoplay(),
    ]);
  }
}
